import Styled from 'styled-components';

import { VALID_COLOR } from '../../lib/StyledComponents';

import { IBannerProps  } from './Banner';

const DEFAULT_STYLE: VALID_COLOR = 'default';

// Wrapping in a span so both a tags and react-router Links will get styled correctly.
export const BannerLink = Styled.span<IBannerProps>`
  a {
    color: ${({ theme: { banner }, bannerStyle }) => banner[bannerStyle || DEFAULT_STYLE].colorLink};
    font-weight: ${({ theme: { banner }}) => banner.linkTextWeight};
    text-decoration: underline;
  }
`;

BannerLink.defaultProps = {
  bannerStyle: 'primary',
};

BannerLink.displayName = 'BannerLink';
